import { LAYERS, DOWN_PLACEMENTS } from 'bloko/blocks/drop/constants';

export const defaultProps = {
    layer: LAYERS.aboveContent,
    onlySetPlacement: false,
    placement: DOWN_PLACEMENTS.bottomStart,
    dataQa: 'bloko-drop-down',
    showCloseButton: false,
};

export const BASE_CLASS_NAMES = ['bloko-drop_down', 'bloko-drop_theme-light'];

export const BEHAVIOR = {
    showArrow: false,
    arrowSize: 0,
    setupFullWidthOnXS: true,
    placementOffset: 0,
    alignToActivatorBorders: true,
};
